import React from "react"

export const PlayButton = () => (
  <svg
    width="45px"
    height="45px"
    viewBox="0 0 45 45"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Group</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Desktop-+-Mobile"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="A14_Desktop-Artist-Profile"
        transform="translate(-1254.000000, -2875.000000)"
      >
        <g id="Videos" transform="translate(34.000000, 2840.000000)">
          <g transform="translate(656.000000, 0.000000)" id="Group-2">
            <g transform="translate(13.000000, 0.000000)">
              <g id="Group" transform="translate(552.000000, 36.000000)">
                <path
                  d="M43,21.5 C43,33.373375 33.3747187,43 21.5,43 C9.626625,43 0,33.373375 0,21.5 C0,9.62528125 9.626625,0 21.5,0 C33.3747187,0 43,9.62528125 43,21.5 Z"
                  id="Stroke-1"
                  stroke="#000000"
                  stroke-width="1.33"
                />
                <polygon
                  id="Fill-3"
                  fill="#000000"
                  points="17 15 29 21.5 17 28"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
